import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";
import {LocationSearchData} from "./location.data";

/**
 * Search model for Locations
 */
@Injectable()
export class LocationSearchModel extends SearchModel<LocationSearchData> {

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "outletGroupId";
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}
